import { Roles } from "../../constants/roles";
import { bindRoleClick } from "../../util/tabs/tabs-listener";
import type { RankingsMonthlyTabsForm } from "./rankings-monthly-tabs-form";
import type { RankingsMonthlyTabsHandler } from "./rankings-monthly-tabs-handler";

export class RankingsMonthlyTabsListener {
    public form: RankingsMonthlyTabsForm;

    public handler: RankingsMonthlyTabsHandler;

    public constructor(form: RankingsMonthlyTabsForm, handler: RankingsMonthlyTabsHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        this.registerTypeTabs();
        this.registerMonthPicker();
        this.registerParentTabs();
    }

    public registerTypeTabs(): void {
        bindRoleClick(this.form.getRoot(), Roles.RANKINGS_MONTHLY_TAB, (event, element) => {
            this.handler.handleTypeTabClick(event, element.dataset.rankingType);
        });
    }

    public registerMonthPicker(): void {
        const monthInput = this.form.getMonthInput();
        if (monthInput instanceof HTMLInputElement) {
            monthInput.addEventListener("change", () => {
                this.handler.handleMonthInputChange();
            });
        }

        const prevButton = this.form.getMonthPrevButton();
        if (prevButton instanceof HTMLButtonElement) {
            prevButton.addEventListener("click", (event) => {
                this.handler.handleMonthPrevClick(event);
            });
        }

        const nextButton = this.form.getMonthNextButton();
        if (nextButton instanceof HTMLButtonElement) {
            nextButton.addEventListener("click", (event) => {
                this.handler.handleMonthNextClick(event);
            });
        }
    }

    public registerParentTabs(): void {
        const parentTabsRoot = this.form.getParentTabsRoot();
        if (!(parentTabsRoot instanceof HTMLElement)) return;

        bindRoleClick(parentTabsRoot, Roles.RANKINGS_MONTHLY_PARENT_TAB, (event, element) => {
            this.handler.handleParentTabClick(event, element.dataset.parentCategoryId);
        });
    }
}
